<script setup>
import { computed, inject, watch } from 'vue'
const rootAppProvide = inject('rootAppProvide')
const props = defineProps({
  show: {
    type: Boolean,
    required: true
  },
  close: {
    type: Function,
    required: false,
    default: undefined
  },
  beforeOpen: {
    type: Function,
    required: false,
    default: undefined
  },
  afterClose: {
    type: Function,
    required: false,
    default: undefined
  },
  color: {
    type: String,
    required: false,
    default: null

  }
})
const emits = defineEmits([
  'update:show'
])

const show = computed({
  get: () => props.show,
  set: (value) => {
    emits('update:show', value)
  }
})
const closeModalHandle = () => {
  if (props.close) {
    props.close()
  } else {
    show.value = false
  }
}
const beforeOpenHandle = () => {
  if (!props.beforeOpen) return
  props.beforeOpen()
}
const afterCloseHandle = () => {
  if (!props.afterClose) return
  props.afterClose()
}

watch(() => rootAppProvide.value.pageName, () => {
  if (show.value === false) return
  closeModalHandle()
})
</script>

<template>
  <Teleport to="#modalPosition">
    <Transition
      @after-leave="afterCloseHandle"
      @before-enter="beforeOpenHandle"
    >
      <div
        v-if="show"
        class="l-modal"
        @click.self="closeModalHandle"
      >
        <div
          class="l-modal__container"
          :class="{'l-modal__container--blue': color}"
        >
          <div class="l-modal__body">
            <slot name="body" />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity .5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  .l-modal__container{
    transition: transform .3s ease;
  }
}

.v-enter-from,
.v-leave-to {
  .l-modal__container{
    transform: scale(1.1);
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity .5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  .modal__container{
    transition: transform .3s ease;
  }
}

.v-enter-from,
.v-leave-to {
  .modal__container{
    transform: scale(1.1);
  }
}

</style>
